// Discover live models + fetch AI news feed
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let _modelsCache = null;
let _modelsCacheTs = 0;
const MODELS_TTL = 15 * 60 * 1000; // 15 minutes client-side

/** Fetch the live list of models from all configured providers.
 *  Returns: [{ id, name, provider, raw }]. Cached 15 min client-side. */
export const fetchLiveModels = async ({ force = false } = {}) => {
  const now = Date.now();
  if (!force && _modelsCache && now - _modelsCacheTs < MODELS_TTL) return _modelsCache;
  try {
    const r = await fetch(`${API}/models/discover${force ? '?force=1' : ''}`);
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const data = await r.json();
    _modelsCache = data.models || [];
    _modelsCacheTs = now;
    return _modelsCache;
  } catch (e) {
    console.warn('YNX: live models fetch failed', e);
    return [];
  }
};

let _newsCache = null;
let _newsCacheTs = 0;
const NEWS_TTL = 5 * 60 * 1000; // 5 minutes client-side

/** Fetch the aggregated AI news feed. Returns: [{title,url,snippet,domain,query}]. */
export const fetchAiNews = async ({ force = false } = {}) => {
  const now = Date.now();
  if (!force && _newsCache && now - _newsCacheTs < NEWS_TTL) return _newsCache;
  try {
    const r = await fetch(`${API}/feed/ai-news?limit=14${force ? '&force=1' : ''}`);
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const data = await r.json();
    _newsCache = data.items || [];
    _newsCacheTs = now;
    return _newsCache;
  } catch (e) {
    console.warn('YNX: AI news fetch failed', e);
    return [];
  }
};
